import styled from "styled-components";
import { colors } from "../../../../../styles/colors";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;

  .title {
    font-size: 10px;
    color: ${colors.blueGray};
  }
`;
